<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <!-- <b-button variant="success mr-1" @click="save">Save</b-button> -->
          <b-button variant="warning" @click="close">Close</b-button>
        </div>
      </div>
      <simpleFormVue
        v-if="modelLoan"
        :itemSimpleForm="itemFormLoan"
        :$v="$v"
        :model="modelLoan"
      />
      <b-tabs content-class="mt-3">
        <b-tab title="Borrower" active>
          <simpleFormVue
            :itemSimpleForm="itemFormBorrower"
            :$v="$v"
            :model="modelBorrower"
          />
        </b-tab>
        <b-tab title="Disbursement">
          <div>
            <b-table
              responsived
              striped
              hover
              small
              :items="disbursementitems"
              :fields="disbursementfields"
              :current-page="tblDtDisbursement.page"
              :per-page="tblDtDisbursement.limit"
            >
              <template #cell()="data">
                <div v-if="data.field.type == 'seq'">
                  {{
                    (tblDtDisbursement.page - 1) * tblDtDisbursement.limit +
                    (data.index + 1)
                  }}
                </div>
                <div v-else-if="data.field.type == 'accounting'">
                  {{ data.item[data.field.key] | numFormat("0,0.00") }}
                </div>
                <div v-else-if="data.field.type == 'date'">
                  {{ data.item[data.field.key] | moment("DD MMM YYYY") }}
                </div>
                <div v-else>
                  {{ data.item[data.field.key] }}
                </div>
              </template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div>
                  Showing
                  {{
                    (tblDtDisbursement.page - 1) * tblDtDisbursement.limit + 1
                  }}
                  to
                  <span
                    v-if="
                      tblDtDisbursement.page * tblDtDisbursement.limit >
                      tblDtDisbursement.total
                    "
                    >{{ tblDtDisbursement.total }}</span
                  >
                  <span v-else>{{
                    tblDtDisbursement.page * tblDtDisbursement.limit
                  }}</span>
                  of {{ tblDtDisbursement.total | numFormat }} entries
                </div>
              </b-col>
              <b-col cols="4">
                <b-form-group
                  label-cols="3"
                  label
                  style="margin-top: 0 !important"
                >
                  <b-input-group>
                    <b-input-group-prepend class="mr-2">
                      <label>Limit per page</label>
                    </b-input-group-prepend>
                    <div class="d-flex">
                      <b-form-select
                        :options="[10, 15, 20, 25]"
                        :plain="true"
                        v-model="tblDtDisbursement.limit"
                        size="sm"
                        style="width: 80px"
                      />
                    </div>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-pagination
                  align="right"
                  :total-rows="tblDtDisbursement.total"
                  :per-page="tblDtDisbursement.limit"
                  v-model="tblDtDisbursement.page"
                >
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-tab>
        <b-tab title="Repayment">
          <div>
            <b-table
              responsived
              striped
              hover
              small
              :items="repaymentitems"
              :fields="repaymentfields"
              :current-page="tblDtRepayment.page"
              :per-page="tblDtRepayment.limit"
            >
              <template v-slot:cell(index)="data">{{
                (tblDtRepayment.page - 1) * tblDtRepayment.limit +
                (data.index + 1)
              }}</template>
              <template v-slot:cell(repayment_date)="data">{{
                data.item.repayment_date | moment("DD MMM YYYY")
              }}</template>
              <template v-slot:cell(principal)="data">{{
                data.item.principal | numFormat("0,0.00")
              }}</template>
              <template v-slot:cell(interest_repaid)="data">{{
                data.item.interest_repaid | numFormat("0,0.00")
              }}</template>
              <template v-slot:cell(total_repayment)="data">{{
                data.item.total_repayment | numFormat("0,0.00")
              }}</template>
            </b-table>
            <b-row class="mt-2">
              <b-col cols="4">
                <div>
                  Showing
                  {{ (tblDtRepayment.page - 1) * tblDtRepayment.limit + 1 }}
                  to
                  <span
                    v-if="
                      tblDtRepayment.page * tblDtRepayment.limit >
                      tblDtRepayment.total
                    "
                    >{{ tblDtRepayment.total }}</span
                  >
                  <span v-else>{{
                    tblDtRepayment.page * tblDtRepayment.limit
                  }}</span>
                  of {{ tblDtRepayment.total | numFormat }} entries
                </div>
              </b-col>
              <b-col cols="4">
                <b-form-group
                  label-cols="3"
                  label
                  style="margin-top: 0 !important"
                >
                  <b-input-group>
                    <b-input-group-prepend class="mr-2">
                      <label>Limit per page</label>
                    </b-input-group-prepend>
                    <div class="d-flex">
                      <b-form-select
                        :options="[10, 15, 20, 25]"
                        :plain="true"
                        v-model="tblDtRepayment.limit"
                        size="sm"
                        style="width: 80px"
                      />
                    </div>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-pagination
                  align="right"
                  :total-rows="tblDtRepayment.total"
                  :per-page="tblDtRepayment.limit"
                  v-model="tblDtRepayment.page"
                >
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import simpleFormVue from "../../components/simpleForm.vue";
toastr.init();

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  components: { Loading, simpleFormVue },
  mixins: [validationMixin],
  validations: {
    model: {},
  },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      isLoading: false,
      modelLoan: {},
      modelBorrower: {},
      itemFormLoan: {
        partnerLoanApplicationNumber: { type: "text", col: 6, disabled: true },
        customerID: { type: "text", col: 6, disabled: true },
        originalLoanAmount: { type: "text", col: 6, disabled: true },
        purposeOfLoan: { type: "text", col: 6, disabled: true },
        purposeOfOpening: { type: "text", col: 6, disabled: true },
        debtorCode: { type: "text", col: 6, disabled: true },
        creditNature: { type: "text", col: 6, disabled: true },
        usageOrientation: { type: "text", col: 6, disabled: true },
        economySector: { type: "text", col: 6, disabled: true },
        projectLocation: { type: "text", col: 6, disabled: true },
        borrowerConfirmationStatus: { type: "text", col: 6, disabled: true },
        disbursement_date_first: { type: "date", col: 6, disabled: true },
        disbursement_amount: { type: "number", col: 6, disabled: true },
        interest_estimate: { type: "number", col: 6, disabled: true },
        interest_arrears: { type: "number", col: 6, disabled: true },
        repayment_principal_date: { type: "date", col: 6, disabled: true },
        principal_repayment: { type: "number", col: 6, disabled: true },
        interest_repaid: { type: "number", col: 6, disabled: true },
        late_fee: { type: "number", col: 6, disabled: true },
        service_Charge: { type: "number", col: 6, disabled: true },
        principal_outstanding: { type: "number", col: 6, disabled: true },
        interest_outstanding: { type: "number", col: 6, disabled: true },
        dpd: { type: "number", col: 6, disabled: true },
        installmentStartDate: { type: "date", col: 6, disabled: true },
        installmentEndDate: { type: "date", col: 6, disabled: true },
        expectedDisbursementDate: { type: "text", col: 6, disabled: true },
      },
      itemFormBorrower: {
        borrowerKey: { type: "text", col: 6, disabled: true },
        customerID: { type: "text", col: 6, disabled: true },
        debtorFullName: { type: "text", col: 6, disabled: true },
        genderCode: { type: "text", col: 6, disabled: true },
        idType: { type: "text", col: 6, disabled: true },
        idNumber: { type: "text", col: 6, disabled: true },
        estimatedYearlyGrossIncome: { type: "text", col: 6, disabled: true },
        sourceOfIncome: { type: "text", col: 6, disabled: true },
        leasePhoneNumber: { type: "text", col: 6, disabled: true },
        mobilePhoneNumber: { type: "text", col: 6, disabled: true },
        placeOfBirth: { type: "text", col: 6, disabled: true },
        dateOfBirth: { type: "text", col: 6, disabled: true },
        professionCode: { type: "text", col: 6, disabled: true },
        employerName: { type: "text", col: 6, disabled: true },
        employerIndustryCode: { type: "text", col: 6, disabled: true },
        motherMaidenName: { type: "text", col: 6, disabled: true },
        maritalStatus: { type: "text", col: 6, disabled: true },
        monthlyIncomeCode: { type: "text", col: 6, disabled: true },
        monthlyIncome: { type: "text", col: 6, disabled: true },
        citizen: { type: "text", col: 6, disabled: true },
        religion: { type: "text", col: 6, disabled: true },
        email: { type: "text", col: 6, disabled: true },
        lastEducationCode: { type: "text", col: 6, disabled: true },
        address: { type: "text", col: 6, disabled: true },
        country: { type: "text", col: 6, disabled: true },
        province: { type: "text", col: 6, disabled: true },
        city: { type: "text", col: 6, disabled: true },
        district: { type: "text", col: 6, disabled: true },
        subDistrict: { type: "text", col: 6, disabled: true },
        postalCode: { type: "text", col: 6, disabled: true },
      },
      tblDtDisbursement: {
        page: 1,
        limit: 15,
        total: 0,
        tablename: "disbursement",
      },
      disbursementfields: [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
          sortable: true,
          type: "seq",
        },
        {
          key: "partnerTransactionId",
          label: "Transaction Id.",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "disbursed_date",
          label: "Date",
          thClass: "text-center",
          sortable: true,
          type: "date",
        },
        {
          key: "due_date",
          label: "Due Date",
          thClass: "text-center",
          sortable: true,
          type: "date",
        },
        {
          key: "loan_amount",
          label: "Amount",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
          type: "accounting",
        },
      ],
      tblDtRepayment: {
        page: 1,
        limit: 15,
        total: 0,
        tablename: "repayment",
      },
      repaymentfields: [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "repayment_date",
          label: "Date",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "principal",
          label: "Principal/Refund",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "interest_repaid",
          label: "Interest",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "total_repayment",
          label: "TOTAL",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      console.log(this.$v.model);
      return this.$v.model.$invalid;
    },
  },
  async created() {
    if (this.$route.params.loan_id) {
      try {
        this.loading = true;
        let loan_id = this.$route.params.loan_id;

        const loanDt = await crud.detail({
          tablename: "loanapplication",
          key: this.$route.params.loan_id,
        });

        let dataFn = {
          page: 1,
          limit: 1,
          total: 0,
          tablename: "borrower",
          customQuery: `customerID=${encodeURIComponent(loanDt.customerID)}`,
        };

        let borrowerDt = await crud.list(dataFn);

        this.modelLoan = loanDt;
        this.modelBorrower = borrowerDt[0];
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("error", error);
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    }
  },
  methods: {
    // save: async function () {
    //   try {
    //     if (this.invalidModel) {
    //       toastr.error("Please fill the form correctly.", "Error Info");
    //     } else {
    //       if (this.model.borrowerKey) {
    //         await crud.update({
    //           tablename: "borrower",
    //           key: this.model.borrowerKey,
    //           data: this.model
    //         });
    //       } else {
    //         await crud.insert({
    //           tablename: "borrower",
    //           data: this.model
    //         });
    //       }
    //       toastr.success(`Success save borrower.`, "Save Borrower", 10000);
    //       this.close();
    //     }
    //   } catch (error) {
    //     if (error.message) {
    //       toastr.error(error.message, "ERROR MESSAGE", 10000);
    //     } else {
    //       toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
    //     }
    //   }
    // },
    async disbursementitems() {
      this.tblDtDisbursement.customQuery = `loan_id=${encodeURIComponent(
        this.$route.params.loan_id
      )}`;

      let disbursementitems = await crud.list(this.tblDtDisbursement);

      return disbursementitems;
    },
    async repaymentitems() {
      this.tblDtRepayment.customQuery = `loan_id=${encodeURIComponent(
        this.$route.params.loan_id
      )}`;

      let repaymentitems = await crud.list(this.tblDtRepayment);

      return repaymentitems;
    },
    close() {
      router.push({ name: "transaction.loan" });
    },
  },
};
</script>